import { render, staticRenderFns } from "./IconOnOff.vue?vue&type=template&id=5a9160f6&"
import script from "./IconOnOff.vue?vue&type=script&lang=js&"
export * from "./IconOnOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports